<template>
  <section>
    <div v-if="loading">
      <!-- Edit -->
      <div class="intro-y box mt-6" v-if="boxedit" ref="boxedit">
        <div
          class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
        >
          <h2 class="font-medium text-base mr-auto">Editar Usuario</h2>
        </div>
        <form @submit.prevent="updateUser">
          <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
            <div class="col-span-6 sm:col-span-6">
              <label>Nombre:</label>
              <input
                v-on:input="updateValue('name', $event)"
                type="text"
                class="input w-full border mt-2 flex-1"
                :value="user.name"
                required
              />
            </div>
            <div class="col-span-6 sm:col-span-6">
              <label>Apodo:</label>
              <input
                v-on:input="updateValue('nickname', $event)"
                type="text"
                class="input w-full border mt-2 flex-1"
                :value="user.nickname"
                required
              />
            </div>
            <div class="col-span-6 sm:col-span-6">
              <label>Correo:</label>
              <input
                v-on:input="updateValue('email', $event)"
                type="email"
                class="input w-full border mt-2 flex-1"
                :value="user.email"
                required
              />
            </div>
            <div class="col-span-6 sm:col-span-6">
              <label>Contraseña (opcional):</label>
              <input
                v-on:input="updateValue('password', $event)"
                type="text"
                class="input w-full border mt-2 flex-1"
                :value="user.password"
              />
            </div>
            <div class="col-span-3 sm:col-span-3">
              <label>Equipo</label>
              <select
                class="input w-full border mt-2"
                v-on:input="updateValue('team_id', $event)"
                :value="user.team_id"
                required
              >
                <option disabled>Seleccione el equipo</option>
                <option v-for="team in teams" v-bind:value="team.id">
                  {{ team.name }}
                </option>
              </select>
            </div>
            <div class="col-span-3 sm:col-span-3">
              <label>Perfil</label>
              <select
                class="input w-full border mt-2"
                v-on:input="updateValue('profile_id', $event)"
                :value="user.profile_id"
                required
              >
                <option disabled>Seleccione el equipo</option>
                <option v-for="profile in profiles" v-bind:value="profile.id">
                  {{ profile.name }} - {{ profile.team.name }}
                </option>
              </select>
            </div>
            <div class="col-span-4 sm:col-span-4">
              <label>Role</label>
              <select
                class="input w-full border mt-2"
                v-on:input="updateValue('role', $event)"
                :value="user.roles[0].id"
                required
              >
                <option disabled>Seleccione el role</option>
                <option value="2">Administrativo</option>
                <option value="3">Lider</option>
                <option value="5">Coordinador</option>
                <option value="4">Trabajador</option>
              </select>
            </div>
            <div class="col-span-4 sm:col-span-4">
              <label>Estado</label>
              <select
                class="input w-full border mt-2"
                v-on:input="updateValue('active', $event)"
                :value="user.active"
                required
              >
                <option disabled>Seleccione el usuario</option>
                <option value="0">Inactivo</option>
                <option value="1">Activo</option>
              </select>
            </div>
            <div class="col-span-4 sm:col-span-4">
              <label>ID Compañia</label>
              <input
                type="integer"
                class="input w-full border mt-2 flex-1"
                v-on:input="updateValue('id_company', $event)"
                :value="user.id_company"
                required
              />
            </div>
            <div class="col-span-2 sm:col-span-2">
                <label>Cumpleaños</label>
                <input
                  type="date"
                  class="input w-full border mt-2 flex-1"
                  v-on:input="updateValue('birthday', $event)"
                  :value="user.birthday"
                  required
                />
            </div>
            <div class="col-span-3 sm:col-span-4">
                  <label>Bono Cumpleaños</label>
                  <input
                    type="text"
                    class="input w-full border mt-2 flex-1"
                    v-on:input="updateValue('prize', $event)"
                    :value="user.prize"
                  />
            </div>
            <div class="col-span-2 sm:col-span-2">
                    <label>Fecha Ingreso</label>
                    <input
                      type="date"
                      class="input w-full border mt-2 flex-1"
                      v-on:input="updateValue('admission_date', $event)"
                      :value="user.admission_date"
                    />
            </div>
            <div class="col-span-3 sm:col-span-3">
                <label>Foto</label>
                <EditPhoto :user=user></EditPhoto>
            </div>
            <div class="col-span-6 sm:col-span-6">
                <label>Url foto PNG</label>
                <input
                  type="text"
                  class="input w-full border mt-2 flex-1"
                  v-on:input="updateValue('img_png', $event)"
                  :value="user.img_png"
                />
            </div>
          </div>
          <div class="px-5 py-3 text-right border-t border-gray-200">
            <button
              type="button"
              v-on:click="closeEditUser()"
              class="button w-20 border text-gray-700 mr-1"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="button w-20 bg-theme-1 text-white"
              id="update"
            >
              Modificar
            </button>
          </div>
        </form>
      </div>
      <!-- END: Edit -->

      <!-- Filter -->
      <div class="intro-y flex flex-col-reverse mt-3 sm:flex-row items-center">
        <h2 class="intro-y text-lg font-medium mr-auto mt-2">
          Usuarios ({{ filteredUsers.length }})
        </h2>
        <!-- filter -->
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
          <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
            <app-icon
              v-bind:name="'search'"
              v-bind:classname="'w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700'"
            ></app-icon>
            <input
              type="text"
              class="input w-full sm:w-64 box px-10 text-gray-700"
              placeholder="Buscar por nombre"
              v-model="filter.name"
            />
          </div>

          <div
            class="inbox-filter dropdown absolute inset-y-0 mr-3 right-0 flex items-center"
          >
            <app-icon
              name="chevron-down"
              classname="dropdown-toggle w-4 h-4 cursor-pointer text-gray-700"
            />
            <div
              class="inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
            >
              <div class="dropdown-box__content box p-5">
                <div class="grid grid-cols-12 gap-4 row-gap-3">
                  <div class="col-span-6">
                    <div class="text-xs">Equipo</div>
                    <select
                      class="input w-full border mt-2 flex-13"
                      v-model="filter.team"
                    >
                      <option :value="null">Seleccione una opción</option>
                      <option
                        v-for="team in teams"
                        :value="team.id"
                        :key="team.id"
                      >
                        {{ team.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-span-6">
                    <div class="w-full sm:w-auto flex">
                      <button
                        @click="filter = clearFilter()"
                        class="button mt-28 text-white bg-theme-1 shadow-md mr-2"
                      >
                        Borrar Filtro
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end filter -->
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"></div>
        <div class="w-full sm:w-auto flex mr-2">
          <button @click="downloadList"
            class="button text-white bg-theme-1 zoom-in"
          >
            Descargar
          </button>
          <a
            ref="download_users"
            target="_blank"
            rel="noopener noreferrer nofollow"
            class="hidden"
            >Descargar</a
          >
        </div>
        <div class="w-full sm:w-auto flex">
          <a
            data-target="#user"
            data-toggle="modal"
            class="button text-white bg-theme-1 shadow-md mr-2"
            >Crear Usuario</a
          >
        </div>
      </div>
      <!-- END: Filter -->
      <!-- List Incomplete-->
      <div v-if="users_incomplete.length" class="p-4 bg-white mt-5 rounded">
          <p class="mb-2">Los siguientes usuarios no tienen la informacion completa: <b>(Apodo, Cumpleaños, fecha ingreso)</b></p>
          <p v-for="item in users_incomplete">
            - {{ item.name }} ({{ item.email }})
          </p> 
      </div>
      <!-- END: List Incomplete -->

      <!-- List -->
      <div class="intro-y flex grid grid-cols-12 gap-6 mt-5">
        <div
          class="intro-y col-span-12 md:col-span-6"
          v-for="user in filteredUsers"
          :key="user.id"
        >
          <div class="box">
            <div
              class="flex flex-col lg:flex-row items-center p-5 border-b border-gray-200"
            >
              <div class="w-24 h-24 lg:w-12 lg:h-12 image-fit lg:mr-1">
                <img
                  alt="Profile"
                  class="rounded-full"
                  :src="user.avatar"
                  v-if="user.avatar"
                />
                <img
                  alt="Profile"
                  class="rounded-full"
                  src="/static/images/profile.png"
                  v-else
                />
              </div>
              <div
                class="lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
              >
                <a href="#" class="font-medium"
                  >{{ user.name }} ({{ user.roles[0].name }})</a
                >
                <div class="text-gray-600 text-xs">{{ user.email }}</div>
                <div class="text-gray-600 text-xs">
                  {{ user.team ? user.team.name : '-' }} :
                  {{ user.profile ? user.profile.name : '-' }}
                </div>
              </div>
              <div class="flex -ml-2 lg:ml-0 lg:justify-end mt-3 lg:mt-0">
                <a
                  v-if="user.active === 0"
                  v-on:click="editUser(user)"
                  class="pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in"
                  title="Estado"
                >
                  <app-icon
                    v-bind:name="'alert-triangle'"
                    v-bind:classname="'w-4 h-4 mr-2'"
                  ></app-icon>
                </a>
                <router-link
                  :to="`/admin/account-user/${user.id}`"
                  class="pl-2 w-12 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in"
                  :class="{ 'back-red': !user.accounts.length }"
                >
                  {{ user.accounts.length }}
                  <app-icon
                    name="folder"
                    classname="w-4 h-4 ml-1 mr-2"
                  ></app-icon>
                </router-link>
                <router-link
                  :to="'/admin/calendar/' + user.slug"
                  class="pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in"
                >
                  <app-icon
                    v-bind:name="'calendar'"
                    v-bind:classname="'w-4 h-4 mr-2'"
                  ></app-icon>
                </router-link>
                <a
                  v-on:click="editUser(user)"
                  class="pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in"
                >
                  <app-icon
                    v-bind:name="'edit'"
                    v-bind:classname="'w-4 h-4 mr-2'"
                  ></app-icon>
                </a>
                <a
                  v-on:click="removeUser(user)"
                  class="pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in"
                >
                  <app-icon
                    v-bind:name="'trash'"
                    v-bind:classname="'w-4 h-4 mr-2'"
                  ></app-icon>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END: List -->

      <!-- Modal CREATE -->
      <div class="modal" id="user">
        <div class="modal__content modal__content--md">
          <div
            class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
          >
            <h2 class="font-medium text-base mr-auto">Crear Usuario</h2>
          </div>
          <form @submit.prevent="createUser">
            <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
              <div class="col-span-6 sm:col-span-6">
                <label>Nombre:</label>
                <input
                  type="text"
                  class="input w-full border mt-2 flex-1"
                  v-model="user.name"
                  required
                />
              </div>
              <div class="col-span-6 sm:col-span-6">
                <label>Contraseña:</label>
                <input
                  type="password"
                  class="input w-full border mt-2 flex-1"
                  v-model="user.password"
                  required
                />
              </div>
              <div class="col-span-12 sm:col-span-12">
                <label>Correo:</label>
                <input
                  type="email"
                  class="input w-full border mt-2 flex-1"
                  v-model="user.email"
                  required
                />
              </div>
              <div class="col-span-6 sm:col-span-6">
                <label>Equipo</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="user.team_id"
                  required
                >
                  <option disabled>Seleccione el equipo</option>
                  <option v-for="team in teams" v-bind:value="team.id">
                    {{ team.name }}
                  </option>
                </select>
              </div>
              <div class="col-span-6 sm:col-span-6">
                <label>Perfil</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="user.profile_id"
                  required
                >
                  <option disabled>Seleccione el perfil</option>
                  <option
                    v-for="profile in filteredProfiles"
                    v-bind:value="profile.id"
                  >
                    {{ profile.name }}
                  </option>
                </select>
              </div>
              <div class="col-span-6 sm:col-span-6">
                <label>Role</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="user.role"
                  required
                >
                  <option disabled>Seleccione el role</option>
                  <option value="business">Administrativo</option>
                  <option value="leader">Lider</option>
                  <option value="coordinator">Coordinador</option>
                  <option value="employee">Trabajador</option>
                </select>
              </div>
              <div class="col-span-6 sm:col-span-6">
                <label>ID Compañia</label>
                <input
                  type="integer"
                  class="input w-full border mt-2 flex-1"
                  v-model="user.id_company"
                  required
                />
              </div>
            </div>
            <div class="px-5 py-3 text-right border-t border-gray-200">
              <button
                type="button"
                data-dismiss="modal"
                class="button w-20 border text-gray-700 mr-1"
              >
                Cancelar
              </button>
              <button
                type="submit"
                class="button w-20 bg-theme-1 text-white"
                id="create"
              >
                Crear
              </button>
            </div>
          </form>
        </div>
      </div>
      <!-- Modal CREATE End -->
    </div>

    <div v-else>
      <app-loading></app-loading>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from '@/services/axios'

import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'
import EditPhoto from '@/components/admin/user/EditPhoto'

export default {
  name: 'AdminListUser',
  data() {
    return {
      loading: false,
      boxedit: false,
      user: {
        name: '',
        nickname: '',
        email: '',
        password: '',
        team_id: '',
        profile_id: '',
        role: '',
        entity: 'user',
        id_company: '',
        birthday: '',
        prize: '',
        admission_date: '',
        img_png: ''
      },
      filter: this.clearFilter(),
      user_current: {},
      users_incomplete: [],
    }
  },
  computed: {
    ...mapGetters({
      users: 'getUsers',
      teams: 'getTeams',
      profiles: 'getProfiles',
    }),
    filteredUsers: function () {
      return this.users.filter((item) => {
        if (this.filter.team === null && this.filter.name === '') {
          return item
        }
        if (this.filter.name !== '') {
          return item.name
            .toLowerCase()
            .includes(this.filter.name.toLowerCase())
        }
        if (parseInt(this.filter.team) === item.team_id) {
          return item
        }
      })
    },
    filteredProfiles: function () {
      return this.profiles.filter((item) => {
        if (this.user.team_id === item.team_id) {
          return item
        }
      })
    },
  },
  async beforeMount() {
    //SEND ENTITY AND MUTATION
    this.getAll('user').then(() => {
      this.loading = true
    })
    this.getList('team').then(() => {
      this.loading = true
    })
    this.getList('profile').then(() => {
      this.loading = true
    })
    try {
      await this.getUsersIncomplete()
    } catch (error) {} finally {
        this.loading = true
    }
  },
  methods: {
    clearFilter() {
      return {
        team: null,
        name: '',
      }
    },
    createUser() {
      var vm = this
      window.$('#create').button('loading')
      vm.store(vm.user)
        .then((item) => {
          window.$('#user').modal('hide')
          vm.user = {
            name: '',
            email: '',
            password: '',
            team_id: '',
            profile_id: '',
            role: '',
            entity: 'user',
          }
          vm.$router.replace(vm.$route.query.redirect || '/admin/users')
        })
        .catch((error) => {
          window.$('#create').button('reset')
          vm.user = {
            name: '',
            email: '',
            password: '',
            team_id: '',
            profile_id: '',
            role: '',
            entity: 'user',
          }
        })
    },
    removeUser: function (value) {
      var vm = this
      vm.form = {
        id: value.id,
        entity: 'user',
      }
      vm.remove(vm.form, 'user')
        .then((user) => {
          vm.loading = true
          vm.$router.replace(vm.$route.query.redirect || '/admin/users')
        })
        .catch((message) => {
          vm.loading = true
        })
    },
    editUser: function (value) {
      this.boxedit = true
      this.user = { ...value }
      this.$nextTick(() => {
        this.$refs.boxedit.scrollIntoView({ behavior: 'smooth' })
      })
    },
    closeEditUser: function () {
      this.boxedit = false
      this.user_current = {}
    },
    updateUser: function (value) {
      var vm = this
      vm.form = {
        id: vm.user.id,
        entity: 'user',
        name: vm.user_current.name,
        nickname: vm.user_current.nickname,
        email: vm.user_current.email,
        password_edit: vm.user_current.password,
        active: vm.user_current.active,
        team_id: vm.user_current.team_id,
        profile_id: vm.user_current.profile_id,
        id_company: vm.user_current.id_company,
        birthday: vm.user_current.birthday,
        prize: vm.user_current.prize,
        admission_date: vm.user_current.admission_date,
        role: vm.user_current.role,
        img_png: vm.user_current.img_png,
      }
      vm.loading = false
      vm.update(vm.form)
        .then((item) => {
          vm.loading = true
          vm.boxedit = false
          vm.user = { name: '', entity: 'user' }
          vm.$router.replace(vm.$route.query.redirect || '/admin/users')
        })
        .catch((message) => {
          vm.loading = true
        })
    },
    updateValue(attribute, e) {
      this.user_current[attribute] = e.target.value
    },
    downloadList() {
      axios.get('user/excel').then((response) => {
        const { data } = response
        const { path } = data

        this.$refs.download_users.href = path
        this.$refs.download_users.click()
      })
    },
    async getUsersIncomplete() {
      const { list } = await this.get(
        `/users-incomplete`
      )
      //console.log(list)
      this.users_incomplete = list
    },
    ...mapActions(['get','getAll', 'getList', 'store', 'update', 'remove']),
  },
  components: {
    appIcon: Icon,
    appLoading: Loading,
    EditPhoto
  },
}
</script>



// WEBPACK FOOTER //
// ListUser.vue?6fdca998